var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "aside",
    { attrs: { "aria-label": "Login" } },
    [
      _c("slide-in-overlay", {
        staticClass: "c-login",
        attrs: { "is-open": _vm.isOpen },
        on: { close: _vm.close },
        scopedSlots: _vm._u([
          {
            key: "heading",
            fn: function() {
              return [_vm._v(" " + _vm._s(_vm.translations["Log in"]) + " ")]
            },
            proxy: true
          },
          {
            key: "body",
            fn: function() {
              return [
                _vm.showLogin
                  ? _c("div", [
                      _c("div", { staticClass: "o-input" }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.username,
                              expression: "username"
                            }
                          ],
                          staticClass: "o-input__input",
                          class: {
                            "o-input__input--filled": _vm.username
                          },
                          attrs: {
                            type: "text",
                            name: "username",
                            id: "login-username",
                            required: "required"
                          },
                          domProps: { value: _vm.username },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.username = $event.target.value
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c(
                          "label",
                          {
                            staticClass: "o-input__label",
                            attrs: { for: "login-username" }
                          },
                          [
                            _vm._v(
                              "\n                        " +
                                _vm._s(_vm.translations["Email"]) +
                                "\n                    "
                            )
                          ]
                        )
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "o-input" }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.password,
                              expression: "password"
                            }
                          ],
                          staticClass: "o-input__input",
                          class: {
                            "o-input__input--filled": _vm.password
                          },
                          attrs: {
                            type: "password",
                            name: "password",
                            id: "login-password",
                            required: "required"
                          },
                          domProps: { value: _vm.password },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.password = $event.target.value
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c(
                          "label",
                          {
                            staticClass: "o-input__label",
                            attrs: { for: "login-password" }
                          },
                          [
                            _vm._v(
                              "\n                        " +
                                _vm._s(_vm.translations["Password"]) +
                                "\n                    "
                            )
                          ]
                        )
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "c-login__actions" }, [
                        _c(
                          "div",
                          {
                            staticClass: "c-login__button",
                            class: { "c-login__button--loading": _vm.isLoading }
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "o-btn o-btn--fullwidth c-login__button",
                                on: {
                                  click: function($event) {
                                    return _vm.logIn()
                                  }
                                }
                              },
                              [
                                _vm._v(
                                  "\n                            " +
                                    _vm._s(_vm.translations["Log in"]) +
                                    "\n                        "
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c("inline-loader")
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass:
                              "o-btn o-btn--transparent o-btn--fullwidth",
                            on: {
                              click: function($event) {
                                return _vm.showReset()
                              }
                            }
                          },
                          [
                            _vm._v(
                              "\n                        " +
                                _vm._s(_vm.translations["Forgot password"]) +
                                "\n                    "
                            )
                          ]
                        )
                      ])
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.showResetPassword
                  ? _c("div", [
                      _c("h2", [
                        _vm._v(_vm._s(_vm.translations["Reset password"]))
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "o-input" }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.username,
                              expression: "username"
                            }
                          ],
                          staticClass: "o-input__input",
                          class: {
                            "o-input__input--filled": _vm.username
                          },
                          attrs: {
                            type: "text",
                            name: "username",
                            id: "login-username",
                            required: "required"
                          },
                          domProps: { value: _vm.username },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.username = $event.target.value
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            attrs: {
                              label: "o-input__label",
                              for: "login-username"
                            }
                          },
                          [
                            _vm._v(
                              "\n                        " +
                                _vm._s(_vm.translations["Email"]) +
                                "\n                    "
                            )
                          ]
                        )
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "c-login__actions" }, [
                        _c(
                          "div",
                          {
                            staticClass: "c-login__button",
                            class: { "c-login__button--loading": _vm.isLoading }
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass: "o-btn o-btn--fullwidth",
                                on: {
                                  click: function($event) {
                                    return _vm.resetPassword()
                                  }
                                }
                              },
                              [
                                _vm._v(
                                  "\n                            " +
                                    _vm._s(_vm.translations["Reset password"]) +
                                    "\n                        "
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c("inline-loader")
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "return",
                            on: {
                              click: function($event) {
                                return _vm.showLoginForm()
                              }
                            }
                          },
                          [
                            _vm._v(
                              "\n                        " +
                                _vm._s(
                                  _vm.translations["Back to log in form"]
                                ) +
                                "\n                    "
                            )
                          ]
                        )
                      ])
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.passwordReset
                  ? _c("div", [
                      _c("h2", [
                        _vm._v(_vm._s(_vm.translations["Reset password"]))
                      ]),
                      _vm._v(" "),
                      _c("div", [
                        _vm._v(
                          "\n                    " +
                            _vm._s(
                              _vm.translations[
                                "If an account with the given username exists, you will shortly receive a email with an reset link in it."
                              ]
                            ) +
                            "\n                "
                        )
                      ])
                    ])
                  : _vm._e()
              ]
            },
            proxy: true
          }
        ])
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }